import React from "react";

function LoadingBar() {
  return (
    <div className="w-full">
      <div className="h-1.5 w-full bg-blue-200 overflow-hidden">
        <div className="progress w-full h-full bg-blue-600 left-right"></div>
      </div>
    </div>
  );
}

export default LoadingBar;
